import script from "./NewsFeed.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsFeed.vue?vue&type=script&setup=true&lang=js"

import "./NewsFeed.vue?vue&type=style&index=0&id=00e7f8b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00e7f8b4"]])

export default __exports__